import { render, staticRenderFns } from "./CarteiraCadastroCargosApp.vue?vue&type=template&id=0208bac4&scoped=true"
import script from "./CarteiraCadastroCargosApp.vue?vue&type=script&lang=js"
export * from "./CarteiraCadastroCargosApp.vue?vue&type=script&lang=js"
import style0 from "./CarteiraCadastroCargosApp.vue?vue&type=style&index=0&id=0208bac4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0208bac4",
  null
  
)

export default component.exports